/**
 * [ File :: G_Canvas.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/frame/G_Canvas.js
 * @목적 : 그리드 타입 캔버스 B_Canvas.js 상속
 * @진행 :
 * @주의 :
 * @일자 : 2018.mm.dd
 * @작성 : created by SDM
 * @참조 :
 */

import B_CanvasGame     from 'canvas/base/dev/frame/B_CanvasGame';
import B_Sound          from 'canvas/base/dev/sound/B_Sound';
import G_World          from 'canvas/grid/dev/frame/G_World';
import G_Define         from 'canvas/grid/dev/util/G_Define';
import G_Animate        from 'canvas/grid/dev/animate/G_Animate';

const G_Canvas = (function(){

	class G_Canvas extends B_CanvasGame {

		constructor(wrapper, id, queue, cb) {
			super(wrapper, id, queue, cb);

			// [S] gameType, animate, sound
			this._gameType = G_Define.GAME_TYPE;
			this.ANIMATE = new G_Animate(this);
			this.SOUND = new B_Sound( this.mut, G_Define.SOUND_RES, G_Define.SOUND_SRC, this.bgm );
		}

		/**
		 * [ Function (protected) :: _getWorld ]
		 *
		 * @DES :: Control World 객체
		 * @S.E ::
		 */
		_getWorld() { return new G_World(this); }

	}
	return G_Canvas;
}());

export default G_Canvas;



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/frame/G_Canvas.js